const imgUrl = [
  require('../../../assets/img/solutions/物联网.png'),
  require('../../../assets/img/solutions/IOT/flow.png'),
  require('../../../assets/img/solutions/IOT/sim.png'),
  require('../../../assets/img/solutions/IOT/manage.png'),
];

export default imgUrl;
